import React, { useState } from 'react'
import { Box, Button, Typography } from '@mui/material';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import ProjectModalContainer from '../../../containers/common/form/modal/ProjectModalContainer';

const ProjectForm = ({ formik }) => {
    const [project, setProject] = useState(null);
    const [openProject, setOpenProject] = useState(false);
    const handleOpen = () => {
        setOpenProject(true)
    };
    const handleClose = () => {
        setOpenProject(false);
    };

    const selectedProject = (project) => {
        setProject(project);
        formik.setFieldValue('prjUuid', project.prjUuid);
    }


    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
            }}
        >
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                <Button variant="outlined" color="secondary" onClick={() => handleOpen()}>프로젝트 선택</Button>
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
                {project === null ? (
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <Typography variant="subtitle2" component="div">선택된 프로젝트가 없습니다</Typography>
                    </Box>
                ) : (
                    <TableContainer component={Box}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>고객명</TableCell>
                                    <TableCell>사업명</TableCell>
                                    <TableCell>프로젝트 번호</TableCell>
                                    <TableCell>부서</TableCell>
                                    <TableCell>생성자</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                <TableRow >
                                    <TableCell>{project?.partnerInc}</TableCell>
                                    <TableCell>{project?.cstNm}</TableCell>
                                    <TableCell>{project?.prjNo}</TableCell>
                                    <TableCell>{project?.crtDptNm}</TableCell>
                                    <TableCell>{project?.crtNm}</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                )}

            </Box>
            <ProjectModalContainer
                title="프로젝트 찾기"
                open={openProject}
                handleClose={handleClose}
                selectedProject={selectedProject}
            />
        </Box>
    )
}

export default ProjectForm